import React, { useState } from "react";
import "./LoginManage.css";
import images from "../../../Utils/importImages";
import { useDispatch, useSelector } from "react-redux";
import LoginDetails from "./LoginDetails";
import LoginDetailEdit from "./LoginDetailEdit";
import PasswordDetail from "./PasswordDetail";
import PasswordDetailEdit from "./PasswordDetailEdit";
import {
  getLocalStorageJSON,
  setLocalStorageJSON,
} from "../../../Utils/localStorageFunc";
import { setUserLoggedInData } from "../../../Redux/Slices/User_Slices/User-SLICE";
import toast from "react-hot-toast";
import { UpdatePassword } from "../../../Redux/Apis/User-Apis";

function LoginManage() {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  let [loginDetail, setLoginDetail] = useState(userLoggedInData);

  let [EditLoginDetail, setEditLoginDetail] = useState(false);
  let [EditPasswordDetail, setEditPasswordDetail] = useState(false);

  let onCancelLoginDetail = () => {
    setEditLoginDetail(false);
  };
  let onCancelPasswordDetail = () => {
    setEditPasswordDetail(false);
  };

  let onSaveLoginDetail = (data) => {
    let { identifier, form } = data;

    let dd = {
      ...loginDetail,
      [form] : identifier,
      non_auth_prime_is_verified : true
    };

    setLoginDetail(dd);
    dispatch(setUserLoggedInData(dd));
    setEditLoginDetail(false);
  };

  let onSavePasswordDetail = async (data) => {
    try {
      let password = data;

      let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

      let resp = await UpdatePassword(password, userLoggedInData.id, token);

      if (resp.error == false) {
        // ste the fresh login details here
        setLocalStorageJSON("UL", resp.data.token);
        setLoginDetail(resp.data.user);
        dispatch(setUserLoggedInData(resp.data.user));

        toast.success("Password Updated Sucessfully", {
          style: {
            fontFamily: `var(--font-family-proxima_nova-semibold)`,
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },
        });
        setEditPasswordDetail(false);
      }
    } catch (error) {}
  };

  return (
    <div className="userdb-content-right">
      {EditLoginDetail ? (
        <LoginDetailEdit
          authenticator={loginDetail.auth_prime == "email" ? "phone" : "email"}
          loginDetails={loginDetail}
          onClickCancel={onCancelLoginDetail}
          onClickSave={onSaveLoginDetail}
        />
      ) : (
        <LoginDetails
          loginDetail={loginDetail}
          setEditLoginDetail={setEditLoginDetail}
        />
      )}
      {EditPasswordDetail ? (
        <PasswordDetailEdit
          passwordDetails={loginDetail}
          onClickCancel={onCancelPasswordDetail}
          onClickSave={onSavePasswordDetail}
        />
      ) : (
        <PasswordDetail
          passwordDetail={loginDetail}
          setEditPasswordDetail={setEditPasswordDetail}
        />
      )}
    </div>
  );
}

export default LoginManage;
